import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { useHistory } from 'react-router';
import { getTasksRequest } from 'src/store/actions/taskActions';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tableD: {
    maxWidth: '100%',
    tableLayout: 'fixed'
  },
  tableRow: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  contentD: {
    padding: 0
  },
  dividerD: {
    backgroundColor: '#1D3343'
  }
}));

function WorkOrderList(props) {
  const { getTasksRequest, tasks } = props;

  const history = useHistory();
  const { t } = useTranslation('work_order');
  useEffect(() => {
    getTasksRequest();
    // eslint-disable-next-line
  }, []);

  const classes = useStyles();
  return (
    <Page className={classes.root} title="İş Emirleri Listesi">
      <Container maxWidth="lg">
        <TableContainer component={Paper}>
          <Table
            className={classes.tableD}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="left">{t('Musteri')}</TableCell>
                <TableCell>{t('Hizmet')}</TableCell>
                <TableCell>{t('Durum')}</TableCell>
                <TableCell>{t('Garanti_tip')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.tasks
                .filter(t => t.FisNo > 0)
                .map(row => (
                  <TableRow
                    key={row.FisNo}
                    onClick={() =>
                      history.push(`/WorkOrder/${row.FisNo}/summary`)
                    }
                  >
                    <TableCell component="th" scope="row" align="left">
                      {row.Musteri}
                    </TableCell>
                    <TableCell>{row.FisNo}</TableCell>
                    <TableCell>{row.Durum}</TableCell>
                    <TableCell>{row.GARANTI_TIPI_TEXT}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </Page>
  );
}

export default connect(state => ({ tasks: state.tasks1 }), { getTasksRequest })(
  WorkOrderList
);
